import pluralize from "pluralize"

export const getCopyText = (copyText: string) => {
  const singular = pluralize(copyText, 1)
  const plural = pluralize(copyText, 2)
  const byCount = (count: number) => pluralize(copyText, count)
  return { singular, plural, byCount }
}
